export const getCorrectFilePath = (path, pathFile) => {
  if (path) {
    return typeof path === 'string' ? buildUrl(path) : ''
  }
  return pathFile
}

const buildUrl = (path) => {
  if (path.startsWith('blob:') || path.startsWith('data:')) {
    return path
  }

  if (path.includes('http')) {
    return path
  }

  const basePath = process.env.REACT_APP_PATH_FILE
  const needsSlash =
    basePath && !basePath.endsWith('/') && path && !path.startsWith('/')

  return basePath + (needsSlash ? '/' : '') + path
}
